import { useEffect } from "react";

/**
 * Canonical URL, JSON-LD Article, and cleanup for blog posts.
 * Title + meta description: set via RouteTitle + ROUTE_SEO for the same pathname.
 */
export function useBlogArticleSeo({ canonicalPath, headline, description, datePublished, dateModified }) {
  useEffect(() => {
    const base = typeof window !== "undefined" ? `${window.location.origin}${canonicalPath}` : "";
    let link = document.querySelector('link[rel="canonical"]');
    let createdCanonical = false;
    let previousCanonical = "";
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
      createdCanonical = true;
    } else {
      previousCanonical = link.getAttribute("href") || "";
    }
    if (base) link.setAttribute("href", base);

    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Article",
      headline,
      description,
      author: { "@type": "Organization", name: "Zolaid" },
      publisher: { "@type": "Organization", name: "Zolaid" },
      datePublished,
      dateModified: dateModified || datePublished,
      mainEntityOfPage: base ? { "@type": "WebPage", "@id": base } : undefined,
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-zolaid-article-ld", "1");
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      script.remove();
      if (createdCanonical) {
        link.remove();
      } else if (previousCanonical) {
        link.setAttribute("href", previousCanonical);
      }
    };
  }, [canonicalPath, headline, description, datePublished, dateModified]);
}
